import { useEffect, useState } from 'react';
import { ButtonField } from '@wk/components-react16';
import { API_URL } from '../../config/constants';
import HttpService from '../../config/http.service';
import { Toast } from '../../services';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { Privilege } from '../../config/constants/privilege';
import DeleteConfirm from '../../components/DeleteConfirm';
import AddGuidedPromptQuestion from './model/AddGuidedPromptQuestion';
import { hideLoading, showLoading } from '../../store/authReducer';

const GuidedPromptQuestionTab = () => {
    const dispatch = useDispatch();
    const { authUser, authProject } = useSelector((state: RootState) => state.auth);
    const [isOpenAddEdit, setIsOpenAddEdit] = useState(false);
    const [guidedPromptQuestionList, setGuidedPromptQuestionList] = useState([] as any);
    const [isLoad, setIsLoad] = useState(false);
    const [selectedItem, setSelectedItem] = useState({} as any);
    const [isOpenDeleteConfirm, setIsOpenDeleteConfirm] = useState(false);
    const [isEditPrivilege, setIsEditPrivilege] = useState(false);
    const [isDeletePrivilege, setIsDeletePrivilege] = useState(false);

    const addEdit = (item: any) => {
        setSelectedItem(item);
        setIsOpenAddEdit(true);
    }

    const getGuidedPromptQuestion = () => {
        dispatch(showLoading());
        HttpService.getRequest(`${API_URL.GET_GUIDED_PROMPT_QUESTION}/${authProject.id}`).then(
        (res: any) => {
            dispatch(hideLoading());
            setGuidedPromptQuestionList(res ? res : []);
        },
        (err: any) => {
            dispatch(hideLoading());
            Toast(err.message, "error")
        },
        )
    }

    const handleDelete = (item: any) => {
        setIsOpenDeleteConfirm(true);
        setSelectedItem(item);
    }

    const deleteItem = () => {
        HttpService.deleteRequest(`${API_URL.DELETE_GUIDED_PROMPT_QUESTION}/${selectedItem.id}`).then(
            (res: any) => {
                Toast("Guided question deleted successfully.", "success");
                setIsLoad(true);
                setIsOpenDeleteConfirm(false);
                setSelectedItem({});
            },
            (err: any) => {
                setIsOpenDeleteConfirm(false);
                setSelectedItem({});
                Toast(err.message, "error");
            }
        )
    }

    useEffect(() => {
        if (isLoad) {
            getGuidedPromptQuestion();
            setIsLoad(false);
        }
    }, [isLoad]);

    useEffect(() => {
        if (authProject && authProject.id) {
            getGuidedPromptQuestion();
        }
    }, []);

    useEffect(() => {
        if (authUser && authUser.privileges) {
            setIsEditPrivilege(authUser.privileges.includes(Privilege[Privilege.EDIT_GUIDED_PROMPT_QUESTION]));
            setIsDeletePrivilege(authUser.privileges.includes(Privilege[Privilege.DELETE_GUIDED_PROMPT_QUESTION]));
        } else {
            setIsEditPrivilege(false);
            setIsDeletePrivilege(false);
        }
    }, [authUser]);

    return (
        <div className="p-20 wk-card-container mb-0 rounded-3 box-shadow">
            {isEditPrivilege && (
                <div className="wk-row">
                    <div className="wk-col-12 text-right">
                        <ButtonField size={'small'} mode={'ghost'}>
                            <button type="button" className="mr-5" onClick={() => addEdit({})}>
                                Add Question
                            </button>
                        </ButtonField>
                    </div>
                </div>
            )}
            <div className="wk-row mt-10">
                <div className="wk-col-12">
                    <table className="wk-table wk-table-bordered wk-table-small">
                        <thead>
                            <tr>
                                <th>Question</th>
                                <th>Description</th>
                                <th>Example</th>
                                {(isEditPrivilege || isDeletePrivilege) && (<th style={{ width: '80px' }}>Actions</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {guidedPromptQuestionList.length > 0 ? guidedPromptQuestionList.map((item: any, index: number) => (
                                <tr key={index}>
                                    <td>{item.question}</td>
                                    <td>{item.description}</td>
                                    <td>{item.example}</td>
                                    {(isEditPrivilege || isDeletePrivilege) && (
                                        <td>
                                            {isEditPrivilege && <span className="wk-icon-pencil mr-10 cursor" title="Edit"
                                                onClick={() => addEdit(item)}></span>}
                                            {isDeletePrivilege && <span className="wk-icon-trash cursor" title="Delete" onClick={() => handleDelete(item)}></span>}
                                        </td>
                                    )}
                                </tr>
                            )) : (
                                <tr>
                                    <td colSpan={(isEditPrivilege || isDeletePrivilege) ? 4 : 3} className="text-center" style={{ height: '7rem' }}>
                                        No record found.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
            {isOpenAddEdit && <AddGuidedPromptQuestion data={{ isOpenAddEdit, setIsOpenAddEdit, selectedItem, setSelectedItem, setIsLoad }} />}
            {isOpenDeleteConfirm && <DeleteConfirm data={{ isOpenDeleteConfirm, setIsOpenDeleteConfirm, deleteItem, message: `Are you sure you want to delete?` }} />}
        </div>
    );
};

export default GuidedPromptQuestionTab;